import { Link } from 'react-router';
import { useSelector } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';

import RouteNames from 'router/routes';

import Container from 'components/container';
import Logo from 'components/logo';

import s from './footer.module.css';

const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME;
const CURRENT_YEAR = new Date().getFullYear();

function Footer() {
  const i18n = useSelector(appSelectors.translation);

  return (
    <footer className={s.section}>
      <Container>
        <div className={s.wrapper}>
          <Logo />

          <div className={s.links_copyright_wrapper}>
            <ul className={s.links_list}>
              <li>
                <Link to={RouteNames.OFFER} className={s.link}>
                  {i18n.Публичная_оферта}
                </Link>
              </li>
              <li>
                <Link to={RouteNames.POLICY} className={s.link}>
                  {i18n.Политика_конфиденциальности}
                </Link>
              </li>
            </ul>

            <p className={s.copyright}>{PROJECT_NAME} © 2012-{CURRENT_YEAR}</p>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
